module.exports = __webpack_public_path__ + "media/images/dashboard/leaderboard-top-icon-b00b718f1f543804e9a0df0e27f4af70.png";